import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Button, Spinner } from "react-bootstrap";
import Layout from "../../../universal/layout/Layout";
import AlphaBanner from "app/orderTool/components/AlphaBanner";
import { getMetabaseDashboard } from "state/dashboard/actions";

/**
 * Onglet « Dashboard data » : intègre le dashboard Metabase B2B via une iframe
 * d'embed. Le token JWT est signé côté backend (jamais codé en dur ici) et
 * rafraîchi à chaque ouverture de la page.
 */
const DashboardData = () => {
  // Titre de l'onglet navigateur (sinon il reste celui de la page précédente).
  useEffect(() => {
    const prev = document.title;
    document.title = "Dashboard data — Le Moulin";
    return () => { document.title = prev; };
  }, []);

  const dispatch = useDispatch();
  const iframeUrl = useSelector((s) => s.dashboard.iframeUrl);
  const isLoading = useSelector((s) => s.dashboard.isLoading);
  const isInitialized = useSelector((s) => s.dashboard.isInitialized);
  const error = useSelector((s) => s.dashboard.error);

  useEffect(() => {
    dispatch(getMetabaseDashboard());
  }, [dispatch]);

  return (
    <Layout>
      <div style={{ padding: "15px" }}>
        <AlphaBanner feature="Dashboard data" contactConnecteam />
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">Dashboard data</h4>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => dispatch(getMetabaseDashboard())}
            disabled={isLoading}
          >
            Actualiser
          </Button>
        </div>

        {isLoading && !iframeUrl && (
          <div className="text-center py-5">
            <Spinner animation="border" role="status" />
            <div className="mt-2 text-muted">Chargement du dashboard…</div>
          </div>
        )}

        {isInitialized && error && !iframeUrl && (
          <Alert variant="danger">
            <strong>Impossible de charger le dashboard Metabase.</strong>
            <div>{error}</div>
          </Alert>
        )}

        {iframeUrl && (
          <iframe
            title="Dashboard data Metabase"
            src={iframeUrl}
            style={{
              width: "100%",
              height: "calc(100vh - 160px)",
              border: 0,
              borderRadius: 8,
            }}
            allowTransparency
          />
        )}
      </div>
    </Layout>
  );
};

export default DashboardData;
